export default __webpack_public_path__ + "static/HP-valueprop1-fea096396f20b49bea60e0c242325d5d.webp";